import { darken, OPA_20 } from '../themeUtils.js';

export function btnmatrix(ctx) {
    return {
        styles: {
            // radius: 8 (was 4 — matched neither firmware's LV_DPX(8) bg-style radius nor the
            // material-dark sibling's own explicit 8). padding: previously 0, overriding the
            // schema default (10, itself matching lv_theme_material.c's pad_small at medium DPI)
            // for no reason — removed so the correct 10 falls through.
            main: { ...ctx.pretty, radius: 8 },
            // item_buttons — LV_BTNMATRIX_PART_BTN shares the material theme's `bg` style
            // (lv_theme_material.c:1022-1024: bg + bg_click), i.e. white bg / primary border /
            // radius 8 by DEFAULT, matching plain btn.js's own default appearance; bg_click only
            // recolors PRESSED/CHECKED/DISABLED states (handled below via the semantic `states`).
            item_buttons: {
                bg_color:     ctx.COLOR_BG,
                border_color: ctx.primary,
                border_width: 2,
                radius:       8,
                text_color:   ctx.COLOR_BG_TEXT,
                text_font:    32,
                states: {
                    checked:         { bg_color: ctx.primary,                  text_color: '#ffffff' },
                    pressed:         { bg_color: darken(ctx.COLOR_BG, OPA_20),  text_color: ctx.COLOR_BG_TEXT },
                    pressedChecked:  { bg_color: darken(ctx.primary, OPA_20),   text_color: '#ffffff' },
                    disabled:        { text_color: ctx.COLOR_BG_TEXT_DIS },
                    disabledChecked: { bg_color: ctx.COLOR_BTN_DIS,             text_color: ctx.COLOR_BG_TEXT_DIS },
                },
            },
        },
    };
}
